import {useEffect, useState} from 'react'

import {debounce} from '@vio/core/src/utils/debounce'

export const useScrollPosition = (withoutDebounce = false) => {
  const [scrollPosition, setScrollPosition] = useState(0)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const callback = debounce(
      () => {
        setScrollPosition(window.scrollY)
      },
      withoutDebounce ? 0 : 300
    )

    window.addEventListener('scroll', callback)

    return () => {
      window.removeEventListener('scroll', callback)
    }
  }, [])

  return {
    scrollY: scrollPosition
  }
}
